export function getLinkedom() {
  return () => {
    throw new Error("Not implemented on the client");
  }
}
